<template>
  <form action="#">
    <div class="row">
      <div class="col-md-6 col-sm-12" v-if="languageData.en">
        <div class="row my-2">
          <TButton :label="$t(`create_template_english`)" active="true" />
        </div>
        <div class="row">
          <div class="col-12">
            <label>{{ $t(`create_template_title_EN`) }}:</label>
            <div class="form-group">
              <input
                v-model="languageData.en.title"
                type="text"
                :placeholder="$t('Contract Title')"
                :class="[
                  'form-control',
                  ,
                  this.isSubmitted && languageData.en.title === ''
                    ? 'validation-error'
                    : '',
                ]"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>{{ $t(`create_template_country`) }}:</label>
            <div class="form-group">
              <select
                :value="
                  contractCountry !== 'Choose...'
                    ? contractCountry?.toLowerCase()
                    : contractCountry
                "
                @change="onContractCountryChange"
                :disabled="type === 'edit'"
                :class="[
                  'form-control',
                  this.isSubmitted && contractCountry?.trim() === 'Choose...'
                    ? 'validation-error'
                    : '',
                ]"
              >
                <option value="Choose..." selected disabled>
                  {{ $t("Choose...") }}
                </option>
                <option
                  v-for="(country, index) in countries"
                  :key="index"
                  :value="country.toLowerCase()"
                >
                  {{ countryName(country) }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for>{{ $t(`create_template_description_EN`) }}</label>
            <textarea
              cols="30"
              rows="7"
              class="form-control"
              v-model="languageData.en.description"
              :class="[
                'form-control',
                this.isSubmitted && languageData.en.description === ''
                  ? 'validation-error'
                  : '',
              ]"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12" v-if="languageData[this.activeLanguage]">
        <div class="row my-2">
          <TButton
            :label="$t(`create_template_${language.label?.toLowerCase()}`)"
            :lang="language.lang"
            v-for="(language, index) in languages.secondaryLanguages"
            :active="language.lang == activeLanguage"
            :key="index"
            :onClick="setActiveLanguage"
          />
        </div>
        <div class="row">
          <div class="col-12">
            <label
              >{{
                $t(
                  `create_template_title_${this.activeLanguage.toUpperCase()}`
                )
              }}:</label
            >
            <div class="form-group">
              <input
                type="text"
                :placeholder="$t('Contract Title')"
                v-model="languageData[this.activeLanguage].title"
                :class="[
                  'form-control',
                  this.activeLanguage === 'ar' && 'text-right',
                  this.isSubmitted &&
                  languageData[this.activeLanguage].title === ''
                    ? 'validation-error'
                    : '',
                ]"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>{{ $t("create_template_type") }}:</label>
            <div class="form-group">
              <select
                class="form-control"
                :value="contractType"
                @change="onContractTypeChange"
              >
                <option value="free_occupancy">
                  {{ $t("Occupancy Free of Charge Lease") }}
                </option>
                <option value="standard_residential">
                  {{ $t("Standard Residential Lease") }}
                </option>
                <option value="rent_reduction">
                  {{ $t("Rent Reduction Lease") }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for>{{
              $t(
                `create_template_description_${this.activeLanguage.toUpperCase()}`
              )
            }}</label>
            <textarea
              cols="30"
              rows="7"
              :class="[
                'form-control',
                this.activeLanguage === 'ar' && 'text-right',
                this.isSubmitted &&
                languageData[this.activeLanguage].description === ''
                  ? 'validation-error'
                  : '',
              ]"
              v-model="languageData[this.activeLanguage].description"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import TButton from "@/components/Contracts/templates/TButton.vue";
import { getCountryName } from "@/app-assets/js/get-countries.js";

export default {
  props: [
    "countries",
    "type",
    "languageData",
    "languages",
    "contractCountry",
    "contractType",
    "onContractTypeChange",
    "onContractCountryChange",
  ],
  components: { TButton },
  data() {
    return {
      activeLanguage: "pl",
      isSubmitted: false,
    };
  },
  methods: {
    setActiveLanguage(lang) {
      this.activeLanguage = lang;
    },
    onOpen() {
      this.isSubmitted = false;
      this.activeLanguage = "pl";
    },
    validateData() {
      
      const findLang = ["pl", "ar", "fr"].find(
        (lang) => !this.languageData[lang].title || !this.languageData[lang].description 
      );

      const checkEnglishTerms = ["en"].find(
        (lang) => !this.languageData[lang].title  || !this.languageData[lang].description 
      );
      
      this.activeLanguage = findLang || this.activeLanguage;

      return !findLang && !checkEnglishTerms;
    },
    onSubmit() {
      this.isSubmitted = true;
      return this.validateData() && this.contractType != "" && this.contractCountry != "Choose...";
    },
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
  },
};
</script>

<style scoped>
.validation-error {
  border: solid 1px red !important;
}
</style>
